import React, {Component, Fragment} from 'react';
import style from '../css/lockedAccaBet.css';
import {connect} from 'react-redux';
import {countDecimals, roundNumber} from '../../../helpers/mathFunctions';
import {getFormattedCurrency, getText, usingNonDecimalCurrency} from '../../../helpers/localization';
import {BASE_VALUE} from '../../../constants/chips';
import {getOddsFromOddsType} from "../../../helpers/oddsHelpers";
import {DECIMAL} from '../../../constants/identifiers';
import Accordion from "./accordion";
import {ASSETS_URL} from "../../../constants/endpoints";
import LockedAccaBetDetail from "./lockedAccaBetDetail";
import {getAccaBetName, getPotentialReturn, isMatchDay, isWinningBet} from "../modules/matchday/helpers/matchdayHelper";
import {getGameTitle} from "../../../helpers/eventHelpers";
import {calculateTimeDifference} from '../../../helpers/helperFunctions';
import {getGameByChannel} from '../helpers/gameHelpers';
import {OPERATOR} from '../../../constants/operator';

const mapStateToProps = (state, ownProps) => {
    return {selectedOddsType: state.vpp.selectedOddsType};
};

class LockedAccaBet extends Component {

    constructor(props) {
        super(props);

        let store = this.props.store;
        let storeData = store.getState();

        this.state = {
            isEventDetailsVisible: false,
            selectedOddsType: storeData.vpp.selectedOddsType,
            isAccordionOpen: false,
        };

    }

    componentWillReceiveProps(nextProps) {
        let store = nextProps.store;
        let storeData = store.getState();

        if (nextProps && storeData) {
            this.setState({selectedOddsType: storeData.vpp.selectedOddsType});
        }
    }

    handleAccordionOpenClose = (isOpen) => {
        this.setState({isAccordionOpen: isOpen});
    }

    _getPotentialReturns(stakeValue) {
        let bonusPercentage = this.props.betSelection.Bonus;
        let potentialReturns = getPotentialReturn(this.props.odd, stakeValue, this.props.betSelection.Multiplier, bonusPercentage, this.props.betSelection.PromoId === "real_bet" ? 0 : stakeValue);
        if (usingNonDecimalCurrency(this.props.store.getState().vpp.systemCurrency)) {
            potentialReturns = Math.round(potentialReturns);
        }
        return potentialReturns;
    }

    _getBonusValue() {
        let currentStake = usingNonDecimalCurrency(this.props.store.getState().vpp.systemCurrency) ? this.props.betSelection.Bets[0].Stake : roundNumber((this.props.betSelection.Bets[0].Stake / (this.props.betSelection.Multiplier ? this.props.betSelection.Multiplier : 1)) / BASE_VALUE, 2);
        let bonusPercentage = this.props.betSelection.Bonus;
        if (currentStake && currentStake > 0) {
            if (bonusPercentage && bonusPercentage !== 0) {
                let odd, stake, oddDecimals, stakeDecimals, bonusDecimals;
                oddDecimals = Math.pow(10, countDecimals(this.props.odd));
                stakeDecimals = Math.pow(10, countDecimals(currentStake));
                bonusDecimals = Math.pow(10, countDecimals(bonusPercentage));
                odd = parseFloat(parseFloat(this.props.odd) * parseFloat(oddDecimals)).toFixed(0);
                bonusPercentage = (parseFloat(bonusPercentage) * parseFloat(bonusDecimals)).toFixed(0);
                stake = parseFloat(parseFloat(currentStake) * stakeDecimals).toFixed(0);
                let potentialReturns = roundNumber((stake * odd) / (oddDecimals * stakeDecimals), 2);
                let bonus = (parseFloat(potentialReturns) * parseFloat(bonusPercentage)) / parseFloat(100);
                bonus = bonus / (bonusDecimals);
                return roundNumber(bonus, 2);
            }
        }
        return 0.00;
    }

    _isEmptyGameCycleId(gameCycleId){
        return gameCycleId === undefined || gameCycleId === "";
    }

    render() {
        let systemCurrency = this.props.store != undefined ? this.props.store.getState().vpp.systemCurrency : '';
        let stake = usingNonDecimalCurrency(systemCurrency) ? this.props.betSelection.Bets[0].Stake : roundNumber((this.props.betSelection.Bets[0].Stake / (this.props.betSelection.Multiplier ? this.props.betSelection.Multiplier : 1)) / BASE_VALUE, 2);
        let stakeUI;

        stakeUI = getFormattedCurrency(this.props.store, stake);
        let lockedBetContainerCustomStyle = ''

        let gameCycleId = this.props.betSelection.Bets[0].GameCycleId;
        let gameCycleIdUI = OPERATOR.gameCycleIdEnabled && !this._isEmptyGameCycleId(gameCycleId) ? (<div className={style.gameCycleId}>
            ID: {gameCycleId}
        </div>) : '';

        let bottomContainer;
        let returnsUI;
        let placeHolderUI;
        let outcomeUI;
        let eventDetailsArrow = this.props.isSettledBet && !this.props.voidStatus && this.props.eventDetails
            ? (<div className={style.eventDetailsArrowAndTextContainer}>
                    <div className={style.eventDetailsArrowContainer}>
                        <div
                            className={this.state.isEventDetailsVisible ? style.eventDetailsArrowDown : style.eventDetailsArrowRight}/>
                    </div>
                    <div className={style.eventDetailsText}>{getText('DETAILS', this.props.store)}</div>
                </div>
            )
            : null;

        if (this.props.isSettledBet) {
            prizeNumber = usingNonDecimalCurrency(systemCurrency) ? this.props.betSelection.Bets[0].Prize : (this.props.prize === undefined ? roundNumber(this.props.betSelection.Bets[0].Prize / BASE_VALUE, 2) : this.props.prize);
            let outcomeText = prizeNumber > 0 ? getText('WON', this.props.store) : getText('LOST', this.props.store);

            let prize = getFormattedCurrency(this.props.store, prizeNumber);

            returnsUI = (
                <div className={style.returningsContainer}>
                    <div
                        className={style.actualReturnsLabel}>{this.props.voidStatus ? getText('REFUNDED', this.props.store) : getText('RETURNED', this.props.store)}
                    </div>
                    <div id={'returned_value_' + this.props.index}
                         className={this.props.voidStatus ? style.actualReturnsTextVoided : style.actualReturnsText}>{this.props.voidStatus ? getFormattedCurrency(this.props.store, roundNumber(this.props.betSelection.Bets[0].Stake / BASE_VALUE, 2)) : prize.toString()}</div>
                </div>
            );

            outcomeUI = (
                <div
                    className={`${style.outcomeContainer} ${(prizeNumber > 0 && !this.props.voidStatus)
                        ? style.won
                        : ''}`}>{this.props.voidStatus ? getText('VOIDED', this.props.store) : outcomeText}</div>
            );

            placeHolderUI = (<div className={style.placeHolderContainer}>{eventDetailsArrow}</div>);
            bottomContainer = (
                <div className={!this.props.voidStatus ? style.settledBetBottomContainer : style.bottomContainer}>
                    {placeHolderUI} {outcomeUI} {returnsUI}
                </div>);
        } else {
            let potentialReturns = getFormattedCurrency(this.props.store, 0);
            if (Number(stake) && Number(this.props.odd)) {
                potentialReturns = this._getPotentialReturns(stake);
                if (usingNonDecimalCurrency(this.props.store.getState().vpp.systemCurrency)) {
                    potentialReturns = Math.round(potentialReturns);
                }
                potentialReturns = getFormattedCurrency(this.props.store, potentialReturns);
            }
            let winLoseStakeOddsPotentialReturn = '';
            if(calculateTimeDifference(this.props.betSelection.Bets[0].EventTime, new Date(Date.now() - this.props.store.getState().vpp.serverTimeOffset)) > 0){
                winLoseStakeOddsPotentialReturn = style.winLoseStakeOddsPotentialReturn;
            }
            bottomContainer = (
                <div className={style.potentialReturnsContainer}>
                    <b className={style.potentialReturnsLabel}>{getText('POT_RETURNS', this.props.store)}</b>
                    <b id={'potential_returns_value_' + this.props.index}
                       className={`${style.potentialReturnsText} ${winLoseStakeOddsPotentialReturn}`}>{potentialReturns.toString()}</b>
                </div>
            );
        }

        let odd = getOddsFromOddsType(this.props.odd, DECIMAL);
        let betFooter = !this.props.isSettledBet ? bottomContainer : '';
        let betDetails = this.props.isSettledBet ? bottomContainer : '';
        let game = getGameByChannel(this.props.store, this.props.betSelection.Bets[0].Channel);
        let gameName = game.name
        let gameCategory = game.gameCategory;
        let gameNameElement = isMatchDay(this.props.betSelection.Bets[0].EventType) ? (
                <Fragment>
                    <span>{getText((gameCategory + '_' + gameName).replace(/\s+/g, '_'), this.props.store)}</span>
                    <img className={style.betSlipImg} src={`${ASSETS_URL}${game.assetsPath}/betslipIcon.png`}/>
                </Fragment>
            ) :
            (getText(gameName, this.props.store));
        let content = [];
        this.props.betSelection.Bets.forEach(bet => {
            let key = this.props.index + '_' + bet.EventId;
            let homeTeam = getText("Matchday_" + bet.EventDetails.team1, this.props.store);
            let awayTeam = getText("Matchday_" + bet.EventDetails.team2, this.props.store);
            let title = `${homeTeam} ${getText('VS', this.props.store)} ${awayTeam}`;
            content.push(
                (<LockedAccaBetDetail key={key} bet={bet} store={this.props.store}
                                      isSettledBet={this.props.isSettledBet}
                                      voidStatus={this.props.voidStatus}
                                      eventName={getGameTitle(title, bet.EventTime, this.props.store.getState().vpp.systemLanguage)}
                                      game={game} leagueDay={bet.EventDetails.leagueDay}
                                      score={bet.EventDetails.fullTimeResult ? homeTeam + " " + bet.EventDetails.fullTimeResult.split('').join(' ') + " " + awayTeam : undefined}></LockedAccaBetDetail>)
            );

        });

        let winLoseStyle = '';
        let winLoseBand = '';
        let prizeNumber = '';
        let winLoseBonusInfo = '';
        let winLoseSystemBetType = '';
        let winLoseGameName = '';
        let winLoseStakeOddsPotentialReturn = '';
        if (this.props.isSettledBet) {
            prizeNumber = usingNonDecimalCurrency(systemCurrency) ? this.props.betSelection.Bets[0].Prize : (this.props.prize === undefined ? roundNumber(this.props.betSelection.Bets[0].Prize / BASE_VALUE, 2) : this.props.prize);
        }
        if (prizeNumber !== undefined && this.props.isSettledBet && !this.props.voidStatus) {
            if (prizeNumber > 0 ) {
                winLoseStyle = style.winBackground;
                winLoseBand = style.win;
            } else {
                winLoseStyle = style.loseBackground;
                winLoseBand = style.lose;
            }
            winLoseBonusInfo = style.winLoseBonusInfo;
            winLoseStakeOddsPotentialReturn = style.winLoseStakeOddsPotentialReturn;
            winLoseSystemBetType = style.winLoseSystemBetType;
            winLoseGameName= style.winLoseGameName;
        }

        //delete create logic for color
        let isPromoBet = false;
        if(!(this.props.betSelection.PromoId === "real_bet")){
            lockedBetContainerCustomStyle = `${style.lockedBetContainerPromo}  ${style.lockedBetContainerPromoShadow}`;
            isPromoBet = true;
        } else{
            lockedBetContainerCustomStyle = style.lockedBetContainer;
        }

        if (!this.props.isSettledBet && calculateTimeDifference(this.props.betSelection.Bets[0].EventTime, new Date(Date.now() - this.props.store.getState().vpp.serverTimeOffset)) > 0) {
            let winningsBets = this.props.betSelection.Bets.filter((bet) => (isWinningBet(bet, game, this.props.store.getState().vpp.serverTimeOffset)));

            if (this.props.betSelection.Bets.length === winningsBets.length)
                {winLoseStyle = style.winBackground;
                lockedBetContainerCustomStyle = style.lockedBetContainerPromo;}
            else
                {winLoseStyle = style.loseBackground;
                lockedBetContainerCustomStyle = style.lockedBetContainerPromo;}

            winLoseBonusInfo = style.winLoseBonusInfo;
            winLoseStakeOddsPotentialReturn = style.winLoseStakeOddsPotentialReturn;
            winLoseSystemBetType = style.winLoseSystemBetType;
            winLoseGameName= style.winLoseGameName;
        }

        if (prizeNumber !== undefined && this.props.isSettledBet) {
            if (prizeNumber > 0 && !this.props.voidStatus) {
                lockedBetContainerCustomStyle = style.lockedBetContainerPromo;
            } else if (!this.props.voidStatus) {
                lockedBetContainerCustomStyle = style.lockedBetContainerPromo;
            }
        }
        // let multiplierStyle = OPERATOR.maxRepeatBet < 2 ? style.disableMultiplier : style.systemNumber;
        let accordionKey = 'bet_acca_accordion_' + this.props.index;
        let showBonus = ((this.props.isSettledBet && prizeNumber > 0) || !this.props.isSettledBet);
        let bonusInfo, bonusAmount = '';
        let bonusPercentage = this.props.betSelection.Bonus;
        if (bonusPercentage && bonusPercentage !== 0 && showBonus) {
            let bonusPercentage = parseFloat(this.props.betSelection.Bonus);
            let bonus = getFormattedCurrency(this.props.store, roundNumber(this._getBonusValue(), 2));
            bonusInfo = <Fragment>
                <b className={style.plus}>{getText('+', this.props.store) + ' '}</b>
                {getText('Bonus_Info', this.props.store, [bonusPercentage])}
            </Fragment>
            bonusAmount = <span className={`${style.bonusInfoBoostValue} ${winLoseBonusInfo}`}>
                      {getText('Bonus_Value', this.props.store, [bonus])}
                    </span>
        }
        return (
            <div><Accordion key={this.props.index} id={accordionKey}
                            store={this.props.store}
                            content={content}
                            isSubAccordion={true}
                            isExpanded={this.state.isAccordionOpen}
                            label={`${getText('ACCUMULATOR', this.props.store)}`}
                            collapseKey={""} initiator={'LockedAccaBet'}
                            onHandleAccordionOpenClose={this.handleAccordionOpenClose}/>
                <div className={`${lockedBetContainerCustomStyle}  ${winLoseStyle} ${winLoseBand}`}>
                    <table className={style.accaTable}>
                        <tbody>
                        <tr>
                            <td className={` ${style.systemBetType} ${winLoseSystemBetType}`}>
                                {getText('1', this.props.store) + ' ' + getText('x', this.props.store) + ' '}
                                {getAccaBetName(this.props.betSelection.Bets.length, this.props.store)}
                            </td>
                            <td className={`${style.gameName} ${winLoseGameName}`}>{gameNameElement}</td>
                        </tr>
                        <tr>
                            <td className={ `${style.bonusInfoBoostPercentage} ${winLoseBonusInfo}`}>
                                {bonusInfo}
                                {/* <div className={`${multiplierStyle} ${style.hideMultiplier}`}>{getText('Multiplier', this.props.store)}: {this.props.betSelection.Multiplier?this.props.betSelection.Multiplier:1}</div> */}
                            </td>
                            <td className={style.oddContainer}>
                                <div className={style.oddLabel}>{`${getText('ODDS', this.props.store)}: `}</div>
                                <div
                                    className={this.props.isSettledBet ? `${style.odd} ${winLoseStakeOddsPotentialReturn}` : `${style.odd} ${style.marginHolder} ${winLoseStakeOddsPotentialReturn}`}
                                    id={'odd_' + this.props.index}>{odd}</div>
                            </td>
                        </tr>
                        <tr>
                            <td>{this.props.isSettledBet ? bonusAmount : ''}</td>
                            <td className={style.stakeContainer}>
                                {isPromoBet && <span className={style.giftSpan}><img className={style.giftIconImage} src={`${ASSETS_URL}promo/giftIconWhite.png`} alt='gift' /></span>}
                                <span className={style.stakeLabel}>{`${getText('STAKE', this.props.store)}: `}</span>
                                <span
                                    className={this.props.isSettledBet ? `${style.stake} ${winLoseStakeOddsPotentialReturn}` : `${style.stake} ${style.marginHolder} ${winLoseStakeOddsPotentialReturn}`}>{stakeUI}</span>
                            </td>
                        </tr>
                        {
                            !this.props.isSettledBet ?
                                <tr className={style.accaTableBottomRow}>
                                    <td className={style.bonusDiv}><span>{bonusAmount}</span></td>
                                    <td>{betFooter}</td>
                                </tr> : ''
                        }
                        </tbody>
                    </table>
                    {gameCycleIdUI}
                    {betDetails}
                </div>
            </div>
        );
    }
}

export default connect(mapStateToProps)(LockedAccaBet);



// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/components/lockedAccaBet.js